"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppState;
(function (AppState) {
    AppState["loading"] = "loading";
    AppState["ready"] = "ready";
    AppState["pending"] = "pending";
})(AppState = exports.AppState || (exports.AppState = {}));
//# sourceMappingURL=AppState.enum.js.map